import { addendumRequestsTyped } from "@/api/(requests)/addendumTyped";
import dayjs from "@/lib/helpers/dayjs";
import type { UUID } from "@/core/types";

export type CreateNoteAddendumVariables = {
  addendum: string;
  credentials: string | undefined;
  noteId: UUID;
  patientId: UUID;
  signature: string | undefined;
};

export function createNoteAddendum({
  addendum,
  credentials,
  noteId,
  patientId,
  signature,
}: CreateNoteAddendumVariables) {
  return addendumRequestsTyped.create_note_addendum({
    body: {
      addendum,
      credentials,
      note_id: noteId,
      signature,
      timestamp: dayjs().unix(),
    },
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
